// import LayoutView from '@/components/layout'
// {
//   path: '/',
//   component: LayoutView,
//   children: [
//     { path: '/home', alias: '', name: 'home', meta: { description: '首页' }, component: importComponent('home/index') },
//     { path: '/panda', name: 'panda', meta: { description: '私有登录' }, component: importComponent('login/private_login') },
//     { path: '/contact', name: 'contact', meta: { description: '联系我们' }, component: importComponent('contact/index') },
//     { path: '/service', name: 'service', meta: { description: '公共服务' }, component: importComponent('service/index') },
//     { path: '/data-service', name: 'data-service', meta: { description: '数据服务' }, component: importComponent('dataService/Index') }
//   ]
// },

import Layout2View from '@/components/layout2'
const importComponent = (filePath) => () => import('@/views/' + filePath + '.vue')

export const qdLoginRouter = { path: '/qdmetroLogin', name: 'qdmetroLogin', meta: { description: '青岛地铁' }, component: importComponent('home/qdmetro') }
export const ynLoginRouter = { path: '/ynLogin', name: 'ynLogin', meta: { description: '云南京建' }, component: importComponent('home/yunnan') }
export const fsLoginRouter = { path: '/fsLogin', name: 'fsLogin', meta: { description: '佛山地铁' }, component: importComponent('home/foshan') }
export const privateLoginRouter = { path: '/panda', name: 'privateLogin', meta: { description: '私有登录' }, component: importComponent('login/private_login') }

export const mainRouter = [
  {
    path: '/',
    component: Layout2View,
    children: [
      { path: '/search/:id?', alias: '', name: 'search', meta: { description: '检索服务' }, component: importComponent('search/index') },
      { path: '/searchResult/:id?', name: 'search-result', meta: { description: '检索结果' }, component: importComponent('search/list2') },
      { path: '/searchStation/:id?', name: 'search-station', meta: { description: '站点详情' }, component: importComponent('search/station') },
      { path: '/review/:id', name: 'search-review', meta: { description: '检索结果预览' }, component: importComponent('search/review') },
      { path: '/contact', name: 'contact', meta: { description: '联系我们' }, component: importComponent('contact/index') },
      { path: '/help', name: 'help', meta: { description: '使用说明' }, component: importComponent('help/index') },
      { path: '/lineHistory', name: 'line-history', meta: { description: '地铁开通历程图' }, component: importComponent('lineHistory/index') },
      { path: '/RoadKing', name: 'road-king', meta: { description: '地铁乘坐路劲' }, component: importComponent('lineHistory/RoadKing') },
      { path: '/introduce', name: 'introduce', meta: { description: '平台简介' }, component: importComponent('help/introduce') },
      { path: '/bidding', name: 'bidding', meta: { description: '招标信息' }, component: importComponent('other/bidding') }
    ]
  },
  // 指定城市的线路开通历程，id指向citycode
  { path: '/mobile/:id?', name: 'mobile', meta: { description: '移动端地铁开通历程图' }, component: importComponent('mobile/index') },
  { path: '/tiktok/:id?', name: 'tiktok', meta: { description: '抖音版地铁开通历程图' }, component: importComponent('mobile/tiktok') },
  { path: '/contact2', name: 'contact2', meta: { description: '移动端联系我们' }, component: importComponent('mobile/contact') },
  // 通过ordercode查看订单采购详情和履约进程，id指向ordercode
  { path: '/order/:id', name: 'order', meta: { description: '移动端订单详情' }, component: importComponent('mobile/order') },
  { path: '/performance/:id', name: 'performance', meta: { description: '移动端订单履约' }, component: importComponent('performance/index') },
  { path: '/demo3d', name: 'demo3d', meta: { description: '地铁站点3D' }, component: importComponent('demo3d/station2') }
]

export const routers = [
  qdLoginRouter,
  ynLoginRouter,
  fsLoginRouter,
  privateLoginRouter,
  ...mainRouter
]
